// src/pages/CadastroUsuario.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../services/firebase';

const CadastroUsuario = () => {
  const navigate = useNavigate();
  const [tipoConta, setTipoConta] = useState('');
  const [formData, setFormData] = useState({
    nomeCompleto: '',
    nomeUsuario: '',
    email: '',
    senha: '',
    confirmarSenha: '',
    creci: '',
    cpf: '',
    nomeEmpresa: '',
    cnpj: '',
    cidade: '',
    estado: 'MT',
    telefone: '',
    descricao: '',
  });
  const [termosAceitos, setTermosAceitos] = useState(false);
  const [erros, setErros] = useState({});
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validarCampos = () => {
    const novosErros = {};
    if (!tipoConta) novosErros.tipoConta = 'Escolha o tipo de conta';
    if (!formData.nomeCompleto)
      novosErros.nomeCompleto = 'Preencha seu nome completo';
    if (!formData.nomeUsuario)
      novosErros.nomeUsuario = 'Escolha um nome de usuário';
    if (!formData.email) novosErros.email = 'Preencha seu e-mail';
    if (!formData.senha) novosErros.senha = 'Digite uma senha';
    if (formData.senha !== formData.confirmarSenha)
      novosErros.confirmarSenha = 'As senhas não conferem';

    if (tipoConta === 'Corretor') {
      if (!formData.creci) novosErros.creci = 'Informe seu CRECI';
      if (!formData.cpf) novosErros.cpf = 'Informe seu CPF';
    }
    if (tipoConta === 'Incorporadora') {
      if (!formData.nomeEmpresa)
        novosErros.nomeEmpresa = 'Informe o nome da empresa';
      if (!formData.cnpj) novosErros.cnpj = 'Informe o CNPJ';
    }
    if (!formData.cidade) novosErros.cidade = 'Escolha uma cidade';
    if (!formData.telefone) novosErros.telefone = 'Informe um telefone';
    if (!termosAceitos) novosErros.termos = 'Você deve aceitar os termos';

    setErros(novosErros);
    return Object.keys(novosErros).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErros({});
    if (!validarCampos()) return;

    setLoading(true);

    try {
      // Criar usuário no Auth
      const credenciais = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.senha
      );
      const uid = credenciais.user.uid;

      // Salvar dados no Firestore
      await setDoc(doc(db, 'users', uid), {
        uid,
        tipoConta,
        nomeCompleto: formData.nomeCompleto,
        nomeUsuario: formData.nomeUsuario,
        email: formData.email,
        creci: formData.creci || '',
        cpf: formData.cpf || '',
        nomeEmpresa: formData.nomeEmpresa || '',
        cnpj: formData.cnpj || '',
        cidade: formData.cidade,
        estado: formData.estado,
        telefone: formData.telefone,
        descricao: formData.descricao,
        criadoEm: new Date(),
      });

      alert('Cadastro realizado com sucesso!');
      navigate('/perfil');
    } catch (err) {
      console.error('Erro ao cadastrar:', err);
      alert('Erro ao criar conta: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-xl mx-auto px-4 py-8 bg-white rounded-2xl shadow-xl">
      <h1 className="text-2xl font-bold mb-4">Criar Conta</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Campos do formulário */}
        {/* (Pode manter os campos conforme seu último código) */}
        {/* Exemplo de campo */}
        <div>
          <label className="block mb-1 font-medium">Tipo de Conta</label>
          <select
            value={tipoConta}
            onChange={(e) => setTipoConta(e.target.value)}
            className="w-full border rounded px-3 py-2"
          >
            <option value="">Selecione</option>
            <option value="Corretor">Corretor</option>
            <option value="Incorporadora">Incorporadora</option>
          </select>
          {erros.tipoConta && (
            <p className="text-red-500 text-sm">{erros.tipoConta}</p>
          )}
        </div>
        {/* Aqui você inclui os outros inputs exatamente como já estavam */}
        {/* Botão */}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white font-medium py-2 rounded hover:bg-blue-700"
        >
          {loading ? 'Cadastrando...' : 'Criar Conta'}
        </button>
      </form>
    </div>
  );
};

export default CadastroUsuario;
